import { FundIcon } from "components/atoms/Icon";
import { Paragraph } from "components/atoms/Typography";

interface FundNameProps {
    fundName: string | null;
}

function FundName({ fundName }: FundNameProps) {
    return (
        <Paragraph style={{ display: "flex", alignItems: "center", gap: "8PX" }}>
            <FundIcon />
            {fundName || "No fund"}
        </Paragraph>
    );
}

export default FundName;
